module.exports = __webpack_public_path__ + "static/img/IMG_20160306_211109.76eb0009.jpg";